import { Empty, Spin } from 'antd';
import { useState } from 'react';
import { CategoryAndSubCategory, useCategory } from '../../../store/category';
import CategoryCard from './CategoryCard';

import styles from './index.module.scss';
import CategoriesSearch from './CategoriesSearch';

function CategoriesContent() {
  const { listAll } = useCategory();
  const [selectedCategory, setSelectedCategory] = useState<CategoryAndSubCategory | null>(null);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h2 className={styles.title}>
              <span>
                <span className={styles.green}>Unsure</span> about when
              </span>{' '}
              <span>or how much to tip?</span>
            </h2>
            <p className={styles.headerDescription}>
              See how your <span className={styles.bold}>peers tip</span> and
              how <span className={styles.bold}>real workers</span> expect to be
              tipped in a variety of industries
            </p>
          </div>

          <div className={styles.searchWrpper}>
            <CategoriesSearch />
          </div>

          <div className={styles.descriptionWrapper}>
            <p className={styles.description}>
              <span className={styles.bold}>
                Tell us how much you tip for the services below. See how others
                tip and what workers in each category expect to be tipped.
              </span>
            </p>
            <p className={styles.description}>
              Tipping is a personal decision and should reflect your
              satisfaction with the service you receive. While there are common
              suggested tip amounts for specific services, others lack an
              industry standard. In the United States, where tipping is often
              expected and requested at an increasing number of businesses, many
              people seek clarity on when and how much to tip. In this section,
              we provide the average tip amount given by customers for a range
              of different services, as well as an average of what service
              providers in that industry expect.
            </p>
          </div>
          <Spin spinning={listAll.loading}>
            {listAll.response?.data.length ? (
              <div className={styles.categoryCardsWrapper}>
                {listAll.response?.data.map((category) => (
                  <CategoryCard
                    key={category.id}
                    category={category}
                    isActive={category.id === selectedCategory?.id}
                    onChange={setSelectedCategory}
                  />
                ))}
              </div>
            ) : (
              <Empty />
            )}
          </Spin>
        </div>
      </div>
    </div>
  );
}

export default CategoriesContent;
